<template>
	<div class="room-left-con">
		<room-left-top-status
			:detailPageData="detailPageData"
			:stableNum="stableNum"
			:beginColor="beginColor"
			:endColor="endColor"
			:monitorStatusStr="monitorStatusStr"
			:num="num"
		/>
		<room-left-status-panel
			:detailPageData="detailPageData"
			:duration="duration"
			:shouldShowEcharts="shouldShowEcharts"
		/>
		<room-left-waveform-panel
			ref="waveformPanel"
			:shouldShowEcharts="shouldShowEcharts"
		/>
	</div>
</template>

<script>
import RoomLeftTopStatus from './RoomLeftTopStatus.vue';
import RoomLeftStatusPanel from './RoomLeftStatusPanel.vue';
import RoomLeftWaveformPanel from './RoomLeftWaveformPanel.vue';

export default {
	name: 'RoomLeftCon',
	components: {
		RoomLeftTopStatus,
		RoomLeftStatusPanel,
		RoomLeftWaveformPanel,
	},
	props: {
		detailPageData: {
			type: Object,
			default: () => ({}),
		},
		stableNum: {
			type: [Number, String],
			default: 0,
		},
		beginColor: {
			type: String,
			default: '#DA9D0B',
		},
		endColor: {
			type: String,
			default: '#65E332',
		},
		monitorStatusStr: {
			type: String,
			default: '',
		},
		num: {
			type: Number,
			default: 0,
		},
		duration: {
			type: String,
			default: '',
		},
		shouldShowEcharts: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		initCharts(echarts, chart1, chart2) {
			const result = {
				chart1: chart1 || null,
				chart2: chart2 || null,
			};

			if (!echarts) {
				return result;
			}

			if (!result.chart1) {
				const chart1Ref = this.getRefChart1();
				if (chart1Ref) {
					result.chart1 = echarts.init(
						chart1Ref,
						null,
						{
							devicePixelRatio: 2.5,
						}
					);
				}
			}

			if (!result.chart2) {
				const chart2Ref = this.getRefChart2();
				if (chart2Ref) {
					result.chart2 = echarts.init(
						chart2Ref,
						null,
						{
							devicePixelRatio: 2.5,
						}
					);
				}
			}

			return result;
		},
		getRefChart1() {
			return this.$refs.waveformPanel && this.$refs.waveformPanel.$refs
				? this.$refs.waveformPanel.$refs.RefChart1
				: null;
		},
		getRefChart2() {
			return this.$refs.waveformPanel && this.$refs.waveformPanel.$refs
				? this.$refs.waveformPanel.$refs.RefChart2
				: null;
		},
	},
};
</script>

<style lang="scss" scoped>
.room-left-con {
	position: relative;
	display: flex;
	flex-direction: column;
	margin-bottom: 15px;
	min-width: 880px;
	min-height: 368px;
}
</style>
